/* MUI */
import { Box, Card, CardContent, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  Objects  */
import { Contract, ContractDate } from 'objects/Contract';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const StackedKPIsCardUsers = ({
    activeUsers,
    backgroundColor,
    subscribedUsers,
    textColor
}) => {
    const { t } = useTranslation();

    return (
        <Card
            elevation={0}
            sx={{
                backgroundColor,
                margin: '0 8px 8px 8px',
                paddingY: '16px'
            }}
            data-testid="stackedKPIsCardUsers"
        >
            <CardContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0
                }}
            >
                <Box display="flex" flexDirection="column">
                    <Typography
                        data-testid="stackedKPIsCardUsersSubscribed"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[0],
                            fontWeight: 600,
                            textTransform: 'uppercase'
                        }}
                    >
                        {t('Reports.Contracts.subscribedUsers')}
                    </Typography>
                    <Typography
                        data-testid="stackedKPIsCardUsersSubscribedNumber"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[4],
                            fontWeight: 600
                        }}
                    >
                        {subscribedUsers}
                    </Typography>
                </Box>
                <Box display="flex" flexDirection="column" mt="8px">
                    <Typography
                        data-testid="stackedKPIsCardUsersActive"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[0],
                            fontWeight: 600,
                            marginTop: '4px',
                            textTransform: 'uppercase'
                        }}
                    >
                        {t('Reports.Contracts.activeUsers')}
                    </Typography>
                    <Typography
                        data-testid="stackedKPIsCardUsersActiveNumber"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[4],
                            fontWeight: 600
                        }}
                    >
                        {activeUsers}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export const StackedKPIsCardContract = ({
    backgroundColor,
    textColor,
    contract
}) => {
    const { t } = useTranslation();

    return (
        <Card
            elevation={0}
            sx={{
                backgroundColor,
                margin: '0 8px 8px 8px',
                paddingY: '16px'
            }}
            data-testid="stackedKPIsCardContract"
        >
            <CardContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center',
                    padding: 0
                }}
            >
                <Box display="flex" flexDirection="column">
                    <Typography
                        data-testid="stackedKPIsCardContractType"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[0],
                            fontWeight: 600,
                            textTransform: 'uppercase'
                        }}
                    >
                        {t('Reports.Contracts.type')}
                    </Typography>
                    <Typography
                        data-testid="stackedKPIsCardContractTypeType"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[3],
                            fontWeight: 600
                        }}
                    >
                        {contract.type === 'month'
                            ? t('Reports.Contracts.monthToMonth')
                            : t('Reports.Contracts.renewal')}
                    </Typography>
                </Box>
                <Box display="flex" flexDirection="column" mt="16px">
                    <Typography
                        data-testid="stackedKPIsCardContractDate"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[0],
                            fontWeight: 600,
                            marginTop: '4px',
                            textTransform: 'uppercase'
                        }}
                    >
                        {t('Reports.Contracts.contractDate')}
                    </Typography>
                    <Typography
                        data-testid="stackedKPIsCardContractDateDate"
                        variant="p"
                        style={{
                            color: textColor,
                            fontSize: FontSizes[3],
                            fontWeight: 600
                        }}
                    >
                        <Contract data={contract}>
                            <ContractDate abbreviatedMonthDate />
                        </Contract>
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};
